export default __webpack_public_path__ + "static/media/Group9257.2318c334.svg";